import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from 'components/App';
import * as serviceWorker from './serviceWorker';
import {BrowserRouter} from 'react-router-dom';
import {Provider} from 'context';
import 'react-quill/dist/quill.snow.css';
import 'react-dates/lib/css/_datepicker.css';


ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter basename='/app'>
      <Provider>
        <App />
      </Provider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
